import { Injectable, Injector } from "@angular/core";
import { AppUserModel } from "../admin/users/user-management-models/app-user.model";
import { DataService } from "./data.service";
import { HttpWrapperService } from "./http.wrapper.service";
import { SessionManagerService } from "./SessionManager/session-manager.service";
import { Router } from "@angular/router";
import { UsersTableSearchState } from "./user-management.service";
import { SaveActionResult } from "../admin/events-screen/event-page-models/save-action-result";
import { observableToPromise } from "../admin/events-screen/utils/observableToPromise";

@Injectable()
export class PasswordResetService {
  constructor(
    dataService: DataService,
    private http: HttpWrapperService,
    private sessionManager: SessionManagerService,
    private injector: Injector,
    private router: Router
  ) {}
  public async resetPasswordForSingleUser(
    user: AppUserModel
  ): Promise<SaveActionResult> {
    try {
      const response = await observableToPromise(
        this.http.post(
          `/django-api/harshama-users/${user.id}/request_password_reset/`,
          {
            email: user.email,
          }
        )
      );
      const body = await response.json();
      if (body) {
        return { success: true, data: body };
      }
      return { success: false, error: body };
    } catch (err) {
      return { success: false, error: err };
    }
  }
  public async resetPassword(
    email: string,
    token: string,
    password: string
  ): Promise<SaveActionResult> {
    try {
      const response = await observableToPromise(
        this.http.post(`/django-api/harshama-users/reset_password/`, {
          email,
          token,
          password,
        })
      );
      const body = await response.json();

      if (body) {
        return { success: true, data: body };
      }
      return { success: false, error: body };
    } catch (err) {
      return { success: false, error: err };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/password-reset.service.ts